import "bootstrap-icons/font/bootstrap-icons.css";

const BASE_CLASS =
    "inline-flex items-center justify-center gap-1.5 border border-orange-900 bg-orange-700 text-sm font-semibold text-white shadow-sm transition hover:bg-orange-800 disabled:cursor-not-allowed disabled:opacity-40";

/**
 * Shared Generate posts CTA — same look & busy state everywhere.
 */
export default function GeneratePostsButton({
    onClick,
    disabled = false,
    busy = false,
    className = "",
    type = "button",
    roundedClassName = "rounded-lg",
    paddingClassName = "px-3 py-2",
    ...rest
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || busy}
            className={`${BASE_CLASS} ${roundedClassName} ${paddingClassName} ${className}`}
            {...rest}
        >
            {busy ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden
                    />
                    Generating posts…
                </>
            ) : (
                <>
                    <i className="bi bi-stars leading-none" aria-hidden />
                    Generate posts
                </>
            )}
        </button>
    );
}
